<template>
    <ob1-popin-modal2 :id="modalId" :aria-labelledby="modalId" @ob1-popin-modal-click="closePopin">
        <div class="h4" v-html="title" />
        <div v-html="subtitle" />
        <iframe
            id="iframe-id"
            class="mobile-recovery-simulator mt-2"
            :src="url"
            title="simulation de valeur de reprise de mobile"
        />
    </ob1-popin-modal2>
</template>

<script>
export default {
    name: "MobileRecoverySimulatorModal",
    props: {
        modalId: {
            type: String,
            required: false,
            default: ""
        },
        title: {
            type: String,
            required: true
        },
        subtitle: {
            type: String,
            required: true
        },
        url: {
            type: String,
            required: true
        }
    },
    computed: {
        modalLabelId: function () {
            return this.modalId + "-label";
        }
    },
    methods: {
        closePopin() {
            $('#iframe-id').attr('src', this.url);
        }
    }
}
</script>

<style lang="scss">
.mobile-recovery-simulator {
    position: relative;
    display: block;
    border: none;
    height: 80vh;
    width: 100%;
}
</style>
